import { RowsPerPage } from '~/src/dash/components/tables/ListViewTable/common';

export interface IInventoryRules {
  ID: number;
  CreatedAt: string;
  UpdatedAt?: string;
  DeletedAt?: string;

  LookupKey: string;
  LookupValue: string;
  RuleType: number; // 1: VMAP, 2: VAST, 3: ORTB
  StartDateTime: string;
  EndDateTime: string;
  TimezoneType: number;
  ContentCategory: string;
  ContentChannel: string;
  ContentContext: string;
  ContentDistributionID: string;
  ContentDistributionName: string;
  ContentEpisode: string;
  ContentGenre: string;
  ContentID: string;
  ContentKeywords: string;
  ContentLanguage: string;
  ContentLength: string;
  ContentNetwork: string;
  ContentProdQuality: string;
  ContentProducerID: string;
  ContentProducer: string;
  ContentRating: string;
  ContentSeason: string;
  ContentSeries: string;
  ContentTaxonomy: string;
  ContentTitle: string;
  ContentURL: string;
  Custom5: string;
  Custom6: string;
  Custom7: string;
  Custom8: string;
  Custom9: string;
  Custom10: string;
  Custom11: string;
  Custom12: string;
  Custom13: string;
  Custom14: string;
  Custom15: string;
  Custom16: string;
  Custom17: string;
  Custom18: string;
  ResponseType: number;
  AdBreaks: string;
}

export interface IInventoryRulesUiParams {
  currPage?: number;
  rowsPerPage?: RowsPerPage;
  activeColumnKeys?: string[];
}

export interface IGetInventoryRulesAPIParams {
  page?: number;
  pageSize?: RowsPerPage;
}

export interface IInventoryRulesResponse {
  InventoryRules: IInventoryRules[];
  TotalRows: number;
}

export interface IAdBreak {
  AdBreakID: number;
  PodDuration: number;
  SlotCount: number;
  MinAdDuration: string;
  MaxAdDuration: string;
  CuePointTypes: string;
  CuePointValue: string;
}

export enum RuleType {
  VMAP = 1,
  VAST = 2,
  ORTB = 3,
}

export const RuleTypeStrings = {
  [RuleType.VMAP]: 'VMAP',
  [RuleType.VAST]: 'VAST',
  [RuleType.ORTB]: 'ORTB',
} as const;

export const RuleTypeNumbers = {
  vmap: RuleType.VMAP,
  vast: RuleType.VAST,
  ortb: RuleType.ORTB,
} as const;

// Utility functions for conversion
export const convertRuleTypeToString = (ruleType: number): string => {
  return RuleTypeStrings[ruleType as RuleType] || 'unknown';
};
